// firtname/lastname/company(optional) e-mail/telefon

import React from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';
import ReCAPTCHA from 'react-google-recaptcha';
import {
  Grid,
  Row,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
  HelpBlock
} from 'react-bootstrap/lib';

import config from '../config';
const {reCapptchaSiteKey} = config;

const SUCCESS_IDENTIFIER = 'success';
const ERROR_IDENTIFIER = 'error';

const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im; // eslint-disable-line

class RegisterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {token: ''};
  }

  handleChange = (key, value) => {
    this.props.handleChange(key, value);
  }

  validationState = key => {
    const value = this.props[key];
    if (!value || value.length === 0) {
      return null;
    }
    if (key === 'phone') {
      return value.match(phoneRegex) ? SUCCESS_IDENTIFIER : ERROR_IDENTIFIER;
    }
    if (key === 'name' && this.props.errorStatus === 409) {
      return ERROR_IDENTIFIER;
    }
    return value.length > 3 ? SUCCESS_IDENTIFIER : ERROR_IDENTIFIER;
  }
  get isFormValid() {
    const keys = [
      'name',
      'firstname',
      'lastname',
      'email',
      'company',
      'phone'
    ];
    const errors = keys.filter(key => {
      const state = this.validationState(key);
      return state === 'error' || state === null;
    });
    return !errors.length;
  }
  get isFormInvalid() {
    return !this.isFormValid;
  }

  recaptchaHandler = token => {
    this.setState({token});
  }
  submit = e => {
    e.preventDefault();
    const {token} = this.state;
    if (this.isFormValid) {
      const form = serialize(e.target, {hash: true});
      const data = {...form, ...{token}};
      if (data['g-recaptcha-response']) {
        delete data['g-recaptcha-response'];
      }
      this.props.onSubmit(data);
    }
  }
  render() {

    const {
      firstname,
      lastname,
      email,
      company,
      phone,
      name,
      errorStatus
    } = this.props;
    const {handleChange, validationState, isFormInvalid} = this;
    return (
      <Grid>
        <Row>
          <Col xs={12} sm={8} smOffset={2} md={6} mdOffset={3}>
            <Form horizontal onSubmit={this.submit}>
              <FormGroup controlId="coin" validationState={validationState('name')}>
                <Col componentClass={ControlLabel} sm={2}>
                    Coin
                </Col>
                <Col sm={10}>
                  <FormControl autoComplete="off" type="text" placeholder="Coin" name="coin-name" value={name} onChange={({target: {value}}) => handleChange('name', value)} />
                  <FormControl.Feedback />
                  {errorStatus === 409 && <HelpBlock>This coin is already registered!</HelpBlock>}

                </Col>
              </FormGroup>

              <FormGroup controlId="firtname" validationState={validationState('firstname')}>
                <Col componentClass={ControlLabel} sm={2}>
                    First name
                </Col>
                <Col sm={10}>
                  <FormControl type="text" placeholder="First name" name="firstname" value={firstname} onChange={({target: {value}}) => handleChange('firstname', value)} />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>

              <FormGroup controlId="lastname" validationState={validationState('lastname')}>
                <Col componentClass={ControlLabel} sm={2}>
                    Last name
                </Col>
                <Col sm={10}>
                  <FormControl type="text" placeholder="Last name" name="lastname" value={lastname} onChange={({target: {value}}) => handleChange('lastname', value)} />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>

              <FormGroup controlId="company" validationState={validationState('company')}>
                <Col componentClass={ControlLabel} sm={2}>
                    Company
                </Col>
                <Col sm={10}>
                  <FormControl type="text" placeholder="Company" name="company" value={company} onChange={({target: {value}}) => handleChange('company', value)} />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>

              <FormGroup controlId="email" validationState={validationState('email')}>
                <Col componentClass={ControlLabel} sm={2}>
                    Email
                </Col>
                <Col sm={10}>
                  <FormControl required type="email" name="email" placeholder="Email" value={email} onChange={({target: {value}}) => handleChange('email', value)} />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>

              <FormGroup controlId="phone" validationState={validationState('phone')}>
                <Col componentClass={ControlLabel} sm={2}>
                    Telephone
                </Col>
                <Col sm={10}>
                  <FormControl required type="tel" name="phone" placeholder="Telephone" value={phone} onChange={({target: {value}}) => handleChange('phone', value)} />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>

              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                </Col>
                <Col sm={10}>
                  <ReCAPTCHA
                    sitekey={reCapptchaSiteKey}
                    onChange={this.recaptchaHandler}
                  />
                </Col>
              </FormGroup>

              <FormGroup>
                <Col smOffset={2} sm={10}>
                  <Button disabled={isFormInvalid} type="submit">Sign in</Button>
                </Col>
              </FormGroup>
            </Form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

RegisterForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  company: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  errorStatus: PropTypes.number
};

export default RegisterForm;



// WEBPACK FOOTER //
// ./src/register/register-form.js